module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/zoom-5501d39590b424a7f7e0d0606231e1a3.svg&quot;;"